(function(){
    'use strict'

    angular
    .module('app.procesarPlanilla')
    .controller('ProcesarPlanilla', ProcesarPlanilla);

    ProcesarPlanilla.$inject = ['$scope', '$animationsSrv', 'ProcesarPlanillaService', 'CalendarizacionesService', 'TiposPlanillaService', 'logger', '$location', 'UserInfoService', 'moment', 'BloqueoXUsuarioService'];

    function ProcesarPlanilla($scope, $animationsSrv, ProcesarPlanillaService, CalendarizacionesService, TiposPlanillaService, logger, $location, UserInfoService, moment, BloqueoXUsuarioService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.tiposPlanilla = [];
        vm.procesarPlanilla = {
            tipoPlanillaId: -1
        };
        vm.calendarizaciones = [];

        vm.title = 'Procesar Planilla';

        getTiposPlanilla();

        vm.goToPlanillaProcesada = function(calendarizacion){
            
            var path = '/planillaProcesada/';

            if(calendarizacion){

                var promise = BloqueoXUsuarioService.getBloqueoXCalendarizacion(calendarizacion.id);

                promise
                .then(function(bloqueo){
                    if(bloqueo){
                        logger.warning(`La calenzarización esta bloqueada por: ${bloqueo.usuarioNombreCompleto}`);
                    }
                    else{
                        $location.path(path + calendarizacion.id);
                    }
                })
                .catch(function(error){
                    $logger.error('Error al verificar bloqueos. ');
                });
            }
            else{
                logger.error('No fue posible cargar los datos de la planilla procesada');
            }
            
        };

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAllForCalendarizacion(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                tiposPlanilla.forEach(tipo => {
                    tipo.fechaInicio = moment(tipo.fechaInicio).toDate();
                    tipo.fechaFinal = moment(tipo.fechaFinal).toDate();
                });
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

        function getAll(tipoPlanillaId){

            var promise = CalendarizacionesService.getAll(UserInfoService.getCompaniaId(), tipoPlanillaId);

            promise
            .then(function(calendarizaciones){
                calendarizaciones.forEach(calendarizacion => {
                    calendarizacion.fechaInicio = moment(calendarizacion.fechaInicio).toDate();
                    calendarizacion.fechaFinal = moment(calendarizacion.fechaFinal).toDate();
                });
                vm.calendarizaciones = calendarizaciones;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener las Planillas.');
                        break;
                }
                
            });
        };

        vm.tipoPlanillaChange = function(tipoPlanillaId){
            if(tipoPlanillaId && tipoPlanillaId !== -1){
                getAll(tipoPlanillaId);
            }          
        };

        vm.procesar = function(calendarizacion) {
            var promise = ProcesarPlanillaService.save(calendarizacion);
                
            promise
            .then(function(response){
                vm.goToPlanillaProcesada(calendarizacion);
                logger.success('Planilla procesada con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                    logger.error(`Hubo un error al procesar la planilla: ${error.data.Message}`);
                        break;
                
                    default:
                        logger.error('Hubo un error al procesar la planilla');
                        break;
                }
            }); 
        };

        vm.recalcular = function(calendarizacion) {

            var promise = BloqueoXUsuarioService.getBloqueoXCalendarizacion(calendarizacion.id);

            promise
            .then(function(bloqueo){
                if(bloqueo){
                    logger.warning(`La calenzarización esta bloqueada por: ${bloqueo.usuarioNombreCompleto}`);
                }
                else{
                    var promise = ProcesarPlanillaService.recalcular(calendarizacion);
                
                    promise
                    .then(function(response){
                        vm.goToPlanillaProcesada(calendarizacion);
                        logger.success('Planilla procesada con éxito.');
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 500:
                            logger.error(`Hubo un error al procesar la planilla: ${error.data.Message}`);
                                break;
                        
                            default:
                                logger.error('Hubo un error al procesar la planilla');
                                break;
                        }
                    }); 
                }
            })
            .catch(function(error){
                $logger.error('Error al verificar bloqueos. ');
            });
        };        

    }
})();